import instance from '@/api/business' 
import { Resale } from '@/types/Resale' 

const BASE_URL = '/resale/im/resale'

export const fetchResale = async () => {
    const response = await instance.post<Resale[]>(BASE_URL)

    return response.data
} 